<template>
  <main class="terms">
    <ContentsHeader />
    <article class="main_content">
      <div class="pankuzu">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a :href="topurl()">トップ</a></li>
          <li class="breadcrumb-item active">運営会社</li>
        </ol>
      </div>

      <div class="terms_list__wrapper">
        <section class="top_link_list">

          <h1 class="page-title"><span style="white-space:pre">運営会社ページ</span></h1>
          <div class="page-body">
            <h1 id="39309f86-a20a-4f47-b3d3-776b885409a3" class=""><span style="white-space:pre">会社概要</span></h1>
            <p id="7d8127f3-a4ea-4336-a352-e541f56f10cf" class=""><strong><span
                  style="white-space:pre">会社名：</span></strong><span style="white-space:pre"> 株式会社PIGNUS</span></p>
            <p id="dc4aec73-426f-43e1-9ab2-7fd32f6f9435" class=""><strong><span
                  style="white-space:pre">URL</span></strong><span style="white-space:pre">：</span><a
                href="https://www.pignus.co.jp/"><span style="white-space:pre">https://www.pignus.co.jp/</span></a>
            </p>
            <p id="5f03dc43-e8ba-4982-b8d0-2fd64d287b95" class=""><strong><span
                  style="white-space:pre">電話番号</span></strong><span style="white-space:pre">：03-6804-3469（代表）</span></p>
            <p id="32b83a14-db61-47e2-8924-5e43b6093eaf" class=""><span style="white-space:pre">FAX：03-6804-3479</span>
            </p>
            <p id="028bfa26-86d6-4dd5-beb4-6d310f8add15" class=""><strong><span
                  style="white-space:pre">設立：</span></strong><span style="white-space:pre"> 2017年1月5日</span></p>
            <p id="542b9204-1f62-446f-93e4-ee5722fb62ac" class=""><strong><span
                  style="white-space:pre">代表取締役：</span></strong><span style="white-space:pre">水戸 将平</span></p>
            <p id="3c1b535c-fe6b-4ffd-ad19-126b628fa08c" class=""><strong><span
                  style="white-space:pre">資本金：</span></strong><span style="white-space:pre">¥10,000,000</span></p>
            <p id="2c48e265-4d7d-46e1-9895-1a81d8dc29e5" class=""><strong><span
                  style="white-space:pre">住所：</span></strong><span style="white-space:pre">〒106-0032
                東京都港区六本木1-4-5 アークヒルズサウスタワー4階</span></p>
            <p id="b4f23d89-c93c-4124-82c9-6d4066ff693e" class=""><strong><span
                  style="white-space:pre">従業員</span></strong><span style="white-space:pre">：60名</span></p>
            <p id="1a1eddbc-1e87-4a9f-b35a-3f992b618045" class="">
            </p>
          </div>

        </section>
      </div>
      <div class="border_divider"></div>
    </article>
    <div style="margin-bottom: 32px" v-if="pager.isDebug">
      <div>デバグ</div>
    </div>
    <ContentsFooter :pager="pager" />
  </main>
</template>

<style>
.terms_list__wrapper .page-body h2 {
  margin-top: 24px;
}

.terms_list__wrapper .page-body h3 {
  margin-top: 16px;
}

.terms_list__wrapper .page-body p {
  padding-top: 8px;
}

.terms_list__wrapper .page-title {
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0.75em;
}

.terms_list__wrapper h1 {
  font-size: 1.875rem;
  margin-top: 1.875rem;
}
</style>

<style scoped>
.terms {
  min-height: 100vh;
  flex-flow: column;
  display: flex;
  background: #F9FBFB;
}

.main_content {
  flex: 1;
}

.terms_list__wrapper {
  background: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.24);
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 8px;
  padding-right: 8px;
}

.terms_maintitle {
  color: #444545;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 16px;
}

.terms_list__date {
  color: #636464;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 4px;
}

.terms_list__description {
  color: #444545;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  margin-bottom: 16px;
}

.terms_list_session {
  border-top: 1px solid #EFF0F0;
  padding-top: 12px;
  padding-bottom: 8px;
}

.terms_list_session__header {
  color: #444545;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 8px;
}

.terms_list_session__body {
  color: #444545;
  font-weight: 400;
  font-size: 14px;
  line-height: 142%;
  margin-bottom: 8px;
}

.terms_list_session__li ol {
  padding-inline-start: 16px;
}
</style>


<script>
// @ is an alias to /src

// eslint-disable-next-line
import tacklebox from "tacklebox";
import ContentsHeader from "@/components/ContentsHeader.vue";
import ContentsFooter from "@/components/ContentsFooter.vue";

import { CompanyPage } from "@/js/page/CompanyPage.js";

export default {
  name: "CompanyView",
  data() {
    return {
      page: new CompanyPage(),
      isNetworking: false,
      title: "",
    };
  },
  mounted() {
    this.title = this.$route.query.title;
    this.pager.changePage(this.page);

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 " + this.title;
  },
  beforeUnmount() {
    //
  },
  methods: {
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
    topurl() {
      return process.env.VUE_APP_SELF;
    },
    categoryurl() {
      return process.env.VUE_APP_SELF + "/#/category";
    },
    kwurl() {
      return process.env.VUE_APP_SELF + "/#/keyword";
    },
    gotoFreeword() {
      this.$router.push({ name: "freeword" });
    },
  },
  components: {
    ContentsFooter,
    ContentsHeader,
  },
  props: {
    pager: Object,
  },
};
</script>
